import React, { ReactNode } from 'react';
import AdminHeader from './AdminHeader';
import AdminSidebar from './AdminSidebar';

interface AdminLayoutProps {
  children: ReactNode;
  activeSection: string;
  onNavigate: (section: string) => void;
  sidebarCollapsed: boolean;
  onToggleSidebar: () => void;
  userRole?: string;
  onRoleChange?: (role: string) => void;
}

const AdminLayout: React.FC<AdminLayoutProps> = ({
  children,
  activeSection,
  onNavigate,
  sidebarCollapsed,
  onToggleSidebar,
  userRole,
  onRoleChange
}) => {
  return (
    <div className="min-h-screen bg-gray-50 dark:bg-gray-900">
      {/* Header */}
      <AdminHeader onToggleSidebar={onToggleSidebar} onNavigate={onNavigate} userRole={userRole} onRoleChange={onRoleChange} />

      <div className="flex pt-16">
        {/* Sidebar */}
        <AdminSidebar
          activeSection={activeSection}
          onNavigate={onNavigate}
          collapsed={sidebarCollapsed}
        />

        {/* Main Content Area */}
        <main
          className={`flex-1 transition-all duration-300 ${
            sidebarCollapsed ? 'ml-16' : 'ml-64'
          }`}
        >
          <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8 py-8">
            {children}
          </div>
        </main>
      </div>
    </div>
  );
};

export default AdminLayout;
